import React from 'react'
import { withRouter } from 'react-router-dom'
import {
	Typography,
	FormControl,
	TextField,
	TextareaAutosize,
	Button,
	CircularProgress,
} from '@material-ui/core'
import { post_query } from './../../functions'
import ImageLoader from './../../containers/modules/ImageLoader'
import DownControl from '../../containers/modules/DownControl'


// add client to part
class PartclientsNew extends React.Component {
	constructor(props){
		super(props)
		this.state = {
			loader: false, 
			name: '',
			country: '',
			category: '',
			link: '',
			description: '',
			img: ''
		}
	}

	saveRecord(){
		this.setState({ loader: true })
		let data = {
			name: this.state.name,
			country: this.state.country,
			category: this.state.category,
			link: this.state.link,
			description: this.state.description,
			img: this.state.img
		}
		post_query('/api/clients/add', data)
		.then((res) => {
			this.props.history.push(`/partclients/view/${res.id}`)
		})
		.catch((err) => {
			this.setState({ loader: false })
		})
	}

	render(){
		return(
			<>
				<Typography variant='h4'>
					Новый клиент в раздел клиентов на сайт
				</Typography>
				<div className='div-flex-row'>
					<div
						style={{ padding: 16 }}
					>
						<ImageLoader 
							width={380}
							height={200}
							img={this.state.img}
							upload={(l) => this.setState({ img: l })}
						/>
					</div>
					<div>
						<div>
							<FormControl
								className='form-item'
							>
								<TextField 
									inputProps={{style:{ width: 700 }}}
									label='Наименование'
									value={this.state.name}
									onChange={(ev) => this.setState({ name: ev.target.value })}
								/>
							</FormControl>
						</div>
						<div>
							<FormControl
								className='form-item'
							>
								<TextField 
									inputProps={{style:{ width: 700 }}}
									label='Категория'
									value={this.state.category}
									onChange={(ev) => this.setState({ category: ev.target.value })}
								/>
							</FormControl>
						</div>
						<div>
							<FormControl
								className='form-item'
							>
								<TextField 
									inputProps={{style:{ width: 700 }}}
									label='Страна'
									value={this.state.country}
									onChange={(ev) => this.setState({ country: ev.target.value })}
								/>
							</FormControl>
						</div>
						<div>
							<FormControl
								className='form-item'
							>
								<TextField 
									inputProps={{style:{ width: 700 }}}
									label='Ссылка'
									value={this.state.link}
									onChange={(ev) => this.setState({ link: ev.target.value })}
								/>
							</FormControl>
						</div>
						<div>
							<FormControl
								className='form-item'
							>
								<TextareaAutosize
									placeholder='Краткое описание'
									rowsMin={5}
									style={{ width: 700 }}
									label='Краткое описание'
									value={this.state.description}
									onChange={(ev) => this.setState({ description: ev.target.value })}
								/>
							</FormControl>
						</div>
					</div>
				</div>
				<DownControl
					loader={this.state.loader}
				>
					<Button
						variant='contained'
						onClick={() => this.props.history.push('/partclients')}
					>
						Отмена
					</Button>
					<Button
						disabled={this.state.loader}
						variant='contained'
						color='primary'
						onClick={() => this.saveRecord()}
					>
						{
							this.state.loader ? (
								<CircularProgress color='inherit' size={24} />
							) : 'Сохранить'
						}
						
					</Button>
				</DownControl>
			</>
		)
	}
}

export default withRouter(PartclientsNew)
